import lang_lt from "./lang/lt.json";
import lang_en from "./lang/en.json";

export default {
  lt: lang_lt,
  en: lang_en
}

